<template>
  <div>
    <div class="main">
      <div class="head">
        <h2>アカウント残高</h2>
        <p>
          現在ご利用可能の金額：{{ balance }}円
          <span>入金確認待ち金額：{{ needConfirmBalance }} 円</span>
        </p>
      </div>
      <div class="content">
        <h2>入出金履歴詳細</h2>
        <div class="search">
          <div class="fl">
            日付
            <el-date-picker v-model="list.dateStart" type="date" placeholder="日付を選択" size="mini"
              value-format="yyyy-MM-dd"></el-date-picker>-
            <el-date-picker v-model="list.dateEnd" type="date" placeholder="日付を選択" size="mini"
              value-format="yyyy-MM-dd"></el-date-picker>
            <el-select v-model="list.keywords" placeholder="選択" size="mini">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <input type="text" v-model="list.ordno" />
            <a href="javascript:;" @click="kin_list">検索</a>
            <a href="javascript:;" @click="empty">リセット</a>
          </div>
          <span style="color: #f3c622">
            <a
              :href="`https://www.rakumart-2c.com/index.php?mod=inc&act=ordersys&str=kin_list&token=${token}&keywords=${list.keywords}&page=${list.page}&pageSize=${list.pageSize}&dateStart=${list.dateStart}&dateEnd=${list.dateEnd}&ordno=&download=1 `">ダウンロード</a>
          </span>
        </div>
        <!-- title -->
        <ol>
          <li>NO</li>
          <li class="fanhao">
            日付
            <img src="../../../assets/img/paixu.png" alt />
          </li>
          <li class="fanhao">注文書・配送書</li>
          <li class="fanhao">内容</li>
          <li>入金額</li>
          <li>出金額</li>
          <li>残金</li>
        </ol>
        <ul v-for="(item, index) in orderList" :key="index">
          <li>
            {{ index + 1 }}
            <input type="checkbox" name id style="margin-left: 5px;" />
          </li>
          <li class="fanhao">{{ item.datetime }}</li>
          <li class="fanhao">
            <div>
              <p v-if="item.ordno.substr(0, 1) == 'P'">
                <router-link :to="'/deliver?pordno=' + item.ordno" target="_blank">
                  配送書： {{ item.ordno }}
                </router-link>
              </p>
              <p v-else-if="item.ordno.substr(0, 1) == '2'">
                <router-link :to="'/zhuwen?ordno=' + item.ordno" target="_blank">
                  注文書： {{ item.ordno }}
                </router-link>
              </p>
              <p v-else>
                <span>
                  {{ item.ordno }}
                </span>
              </p>
              <p>{{ item.realname }}</p>
            </div>

          </li>
          <li class="fanhao beikao">{{ item.beikao }}</li>
          <li>{{ item.kin_in }}</li>
          <li>{{ item.kin_out }}</li>
          <li>{{ item.balance }}</li>
        </ul>
        <div class="fenye">
          <div class="fenye">
            <el-pagination background @current-change="handleCurrentChange" :current-page="list.page" :page-size="20"
              layout=" total,prev, pager, next" :total="total"></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { kin_list } from "../../../api/API/goldenRecord";
export default {
  data() {
    return {
      val: "",
      options: [
        {
          value: "すべて",
          label: "すべて",
        },
        {
          value: "入金",
          label: "入金",
        },
        {
          value: "注文の出金",
          label: "注文の出金",
        },
        {
          value: "落札完了出入金調整",
          label: "落札完了出入金調整",
        },
        {
          value: "入庫完了出入金調整",
          label: "入庫完了出入金調整",
        },
        {
          value: "国際送料の出金",
          label: "国際送料の出金",
        },
        {
          value: "返金",
          label: "返金",
        },
        {
          value: "残金返金",
          label: "残金返金",
        },
        {
          value: "残金支払",
          label: "残金支払",
        },
      ],
      token: localStorage.getItem("token"),
      list: {
        mod: "inc",
        act: "ordersys",
        str: "kin_list",
        token: "",
        keywords: "",
        page: 1,
        pageSize: 20,
        dateStart: "",
        dateEnd: "",
        ordno: "",
      },
      orderList: [],
      balance: "",
      needConfirmBalance: "",
      total: 0,
      value: "",
    };
  },
  created() {
    this.kin_list();
  },
  methods: {
    // 获取列表
    kin_list() {
      this.list.token = this.token;
      console.log(this.list);

      kin_list(this.list).then((res) => {
        if (res.code != 1) return;
        this.orderList = res.data.list;
        this.balance = res.data.balance;
        this.needConfirmBalance = res.data.needConfirmBalance;
        this.total = res.data.total - 0;
        console.log(res);
      });
    },
    handleCurrentChange(val) {
      this.list.page = val;
      this.kin_list();
    },
    // 清空 输入框
    empty() {
      this.list.keywords = "";
      this.list.ordno = "";
      this.list.dateStart = "";
      this.list.dateEnd = "";
    },
  },
};
</script>
<style lang='scss' scoped>
.main {
  width: 1208px;
  margin-bottom: 50px;
  font-size: 16px;

  .head {
    border: 1px solid #ccc;

    h2 {
      height: 40px;
      line-height: 40px;
      background: #eee;
      padding-left: 20px;
      font-size: 18px;
      font-weight: bold;
      border-bottom: 1px solid #ccc;
    }

    p {
      height: 180px;
      line-height: 180px;
      padding-left: 100px;
      font-size: 18px;

      span {
        margin-left: 300px;
      }
    }
  }

  .content {
    margin-top: 20px;
    border: 1px solid #ccc;
    overflow: hidden;
    padding-bottom: 20px;

    h2 {
      height: 40px;
      line-height: 40px;
      background: #eee;
      padding-left: 20px;
      font-size: 18px;
      font-weight: bold;
      border-bottom: 1px solid #ccc;
    }

    .search {
      overflow: hidden;
      margin-top: 10px;
      margin-left: 10px;

      /deep/.el-date-editor {
        width: 150px;
      }

      .el-select {
        margin: 0 5px;
      }

      input {
        border-radius: 3px;
        border: 1px solid #ddd;
        width: 150px;
        height: 25px;
      }

      a {
        display: inline-block;
        margin: 0px 0 0 5px;
        height: 25px;
        line-height: 25px;
        padding: 0 10px;
        font-size: 14px;
        background: #f3c622;
        color: #fff;
        border-radius: 5px;
      }

      span {
        float: right;
        line-height: 30px;
        margin-right: 50px;
        cursor: pointer;
      }
    }

    ol {
      height: 40px;
      line-height: 40px;
      display: flex;
      font-size: 16px;
      font-weight: bold;
      border-bottom: 1px solid #ccc;
    }

    ul {
      display: flex;
      height: 70px;

      border-bottom: 1px solid #ccc;
    }

    li {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;

      a {
        color: #333;

        &:hover {
          color: #666;
          text-decoration: underline;
        }
      }

      img {
        vertical-align: middle;
        cursor: pointer;
      }

      input {
        width: 25px;
        height: 25px;
        vertical-align: middle;
      }
    }

    .fanhao {
      flex: 2;

      p {
        white-space: nowrap;
      }
    }

    .beikao {
      line-height: 35px;
    }
  }
}

.fenye {
  width: 500px;
  margin: 30px auto;
  text-align: center;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #f3c622;
}
</style>